import {
    Box,
    Button,
    Flex,
   
    Select,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue,
  } from "@chakra-ui/react";
  import React, { useEffect, useMemo, useState } from "react";
  import {
    useGlobalFilter,
    usePagination,
    useSortBy,
    useTable,
  } from "react-table";
  
  // Custom components
  import Card from "components/card/Card";
 
  import {  Row } from "react-bootstrap";
  import { IoSettingsOutline } from "react-icons/io5";
  
  const ExpenseTable = (props) => {
    
    const { columnsData, tableData } = props;
    const columns = useMemo(() => columnsData, [columnsData]);
    const data = useMemo(() => tableData, [tableData]);
    const [pageIndex, setPageIndex] = useState(0); 
    const tableInstance = useTable(
      {
        columns,
        data,
        initialState: { pageIndex, pageSize: 20 },
      },
      useGlobalFilter,
      useSortBy,
      usePagination,
    );
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      page,
      prepareRow,
      initialState,
  
      canPreviousPage,
      canNextPage,
      pageOptions,
      pageCount,
      nextPage,
      previousPage,
      setPageSize,
      state: { pageSize },
    } = tableInstance;
    initialState.pageSize = 15;
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  
   
  
 
    useEffect(() => {
      if (data.length === 0) {
        setPageIndex(0); 
      } else if (pageIndex >= pageCount) {
        setPageIndex(pageCount - 1); 
      }
    }, [data, pageCount,pageIndex]); 
  
    return (
      <>
      
  
        <Card
          direction="column"
          w="100%"
          px="0px"
          p={0}
          h="auto"
          justifyContent="space-between"
          overflowX={{ sm: "scroll", lg: "hidden" }}
        >
          <Table {...getTableProps()} variant="simple" className="embrill-table vendor-expense-table" color="gray.500" >
            <Thead>
              
              {headerGroups.map((headerGroup, index) => (
                <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                  {headerGroup.headers.map((column, index) => (
                    <Th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      key={index}
                      borderColor={borderColor}
                    >
                      <Flex
                        align="center"
                        
                        
                      >
                        {column.render("Header")}
                        <span className="ms-1" style={{ width: "20px" }}>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? "🔽"
                              : "🔼"
                            : ""}
                        </span>
                      </Flex>
                    </Th>
                  ))}
                </Tr>
              ))}
            </Thead>
            <Tbody {...getTableBodyProps()}>
              {page.map((row, index) => {
                prepareRow(row);
                return (
                  <Tr {...row.getRowProps()} key={index}>
                    {row.cells.map((cell, index) => {
                      let data = "";
  
                      data = (
                        <Flex align="center">
                          <Text
                            me="10px"
                            
                          >
                            {cell.value}
                          </Text>
                        </Flex>
                      );
                      return (
                        <Td
                          {...cell.getCellProps()}
                          cursor="pointer"
                          key={index}
                         
                          className="embrill-table-data"
                        >
                          {data}
                        </Td>
                      );
                    })}
                  </Tr>
                );
              })}
            </Tbody>
        
          </Table>
          
        <Row>
          <Box display="flex" justifyContent="space-between" className="expense-table-pagination">
          <Text className="total-count">Total Count : {data?.length}</Text>
          <Flex className="flex-page-item" align="self-start" justify="end">
          <Box className="w-14 select-page" display="flex">
            <IoSettingsOutline size={18} className="setting-icon"/>
              <Select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                }}
              >
                {[10,15, 20, 25, 30].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                  {pageSize} per page
                  </option>
                ))}
              </Select>
            </Box>
            <div className="w-15 page-icon">

            <Button  onClick={() => {setPageIndex(pageIndex - 1);previousPage()}} disabled={!canPreviousPage}>
              {"<"}
            </Button>
            {pageIndex + 1} - {pageOptions.length}
            <Button onClick={() => {setPageIndex(pageIndex + 1);nextPage()}} disabled={!canNextPage}>
              {">"}
            </Button>
            </div>
            
            
           
          </Flex>
          </Box>
        </Row>
        </Card>
      </>
    );
  };
  
  export default ExpenseTable;
  